import React, { useCallback } from 'react';
import '../App.css';
import { useMediaQuery, FormControl } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useRecoilState } from 'recoil';
import { mainBlueColor } from '../GlobalState';
import { ResponsiveBar } from '@nivo/bar';
import { isSortValue } from '../GlobalState';
import { BasicSelect } from '../components/parts/input/BasicSelect';
const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: 120
  },
  formControl1: {
    minWidth: 100
  }
}));

type GraphStatus = {
  assignee_user: string;
  target_sales: number;
  actual_sales: number;
  goal_achievement_rate: number;
  target_gross_profit: number;
  actual_gross_profit: number;
  in_progress_target: number;
  in_progress_performance: number;
  // in_progress_achievement_rate: number;
  construction_target: number;
  construction_performance: number;
  // construction_achievement_rate: number;
  completion_target: number;
  completion_performance: number;
  // completion_achievement_rate: number;
};

type GraphStatuses = {
  graphStatus: GraphStatus[];
};

export const PersonalGraph: React.FC<GraphStatuses> = graphStatuses => {
  const matches2 = useMediaQuery('(min-width:900px)');
  const [sortValue, setSortValue] = useRecoilState(isSortValue);
  const [mainColor] = useRecoilState(mainBlueColor);
  const [sortGraphData, setSortGraphData] = React.useState<any>([]);
  const classes = useStyles();
  const dropDownValues: any = [
    { ' 売上': ['target_sales', 'actual_sales'] },
    { 粗利: ['target_gross_profit', 'actual_gross_profit'] },
    {
      '営業中(ランクA)案件': ['in_progress_target', 'in_progress_performance']
    },
    { 工事案件: ['construction_target', 'construction_performance'] },
    { 完了案件: ['completion_target', 'completion_performance'] },
    { '目標達成率 ': ['goal_achievement_rate'] }
  ];
  let targetSales: any = [];
  graphStatuses.graphStatus.forEach((element: any) => {
    targetSales.push(element.target_sales);
  });
  const setsortFun = useCallback(
    (sortItem: any[]) => {
      setSortGraphData([graphStatuses.graphStatus]);

      var x: any = [];

      graphStatuses.graphStatus.forEach((data: any, i: any) => {
        var y: any = {};
        sortItem.forEach(item => {
          //console.log("data///////", data[item], item)
          y[item] = data[item];
          y['assignee_user'] = data['assignee_user'];
        });
        x.push(y);
      });
      setSortGraphData([...x]);
    },
    [graphStatuses.graphStatus]
  );

  React.useEffect(() => {
    graphStatuses.graphStatus.length > 0 && setsortFun(sortValue);
  }, [sortValue, graphStatuses.graphStatus.length, setsortFun]);

  return (
    <div
      style={{ overflowX: 'scroll' }}
      className={
        !matches2
          ? 'responsive-container-bottom-responsive'
          : 'responsive-container-bottom'
      }
    >
      <div
        className='bottom-bar-graph-top-container'
        style={{ marginBottom: 30 }}
      >
        {/* <div className="mg-bottom">社員別粗利実績</div> */}
        <div
          //className="mg-bottom"
          className='select-div'
          //style={{ marginBottom: 30 }}
        >
          <div style={{ paddingLeft: 5 }}>
            <FormControl className={classes.formControl1}>
              <BasicSelect
                value={sortValue}
                onChange={e => {
                  //console.log("e", e.target.value)
                  setSortValue(e.target.value.split(','));
                  //setsortFun();
                }}
                inputProps={{ 'aria-label': 'age' }}
                disableUnderline
              >
                {dropDownValues.map((item: any, index: any) => (
                  //console.log("e", Object.values(item), Object.keys(item))
                  <option value={Object.values(item)}>
                    {Object.keys(item)}
                  </option>
                ))}
              </BasicSelect>
            </FormControl>
          </div>
        </div>

        <div className='bottom-bar-graph-top-container'>
          <div className='square' style={{ backgroundColor: '#CCCCCC' }} />
          {sortValue.length > 1 ? (
            <div className='mg-bottom'>目標</div>
          ) : (
            <div className='mg-bottom'>目標達成率</div>
          )}
          {sortValue.length > 1 && (
            <div className='square' style={{ backgroundColor: '#FFFFFF' }} />
          )}
          {sortValue.length > 1 && (
            <div className='square' style={{ backgroundColor: mainColor }} />
          )}
          {sortValue.length > 1 && <div className='mg-bottom'>実績</div>}
        </div>
      </div>
      <div
        style={{
          height: 350,
          overflowX: 'scroll',
          minWidth: graphStatuses.graphStatus.length * 80
        }}
        // style={{ height: 350, overflowX: "scroll", minWidth: 1000 }}
        key={graphStatuses.graphStatus.toString()}
      >
        {graphStatuses.graphStatus.length === 1 &&
        graphStatuses.graphStatus[0].actual_gross_profit === 0 &&
        graphStatuses.graphStatus[0].actual_sales === 0 &&
        graphStatuses.graphStatus[0].target_gross_profit === 0 &&
        graphStatuses.graphStatus[0].target_sales === 0 &&
        graphStatuses.graphStatus[0].assignee_user === null &&
        graphStatuses.graphStatus[0].in_progress_target === 0 &&
        graphStatuses.graphStatus[0].in_progress_performance === 0 &&
        graphStatuses.graphStatus[0].goal_achievement_rate === 0 &&
        // graphStatuses.graphStatus[0].in_progress_achievement_rate === 0 &&
        graphStatuses.graphStatus[0].construction_target === 0 &&
        graphStatuses.graphStatus[0].construction_performance === 0 &&
        // graphStatuses.graphStatus[0].construction_achievement_rate === 0 &&
        graphStatuses.graphStatus[0].completion_target === 0 &&
        graphStatuses.graphStatus[0].completion_performance === 0 ? (
          // graphStatuses.graphStatus[0].completion_achievement_rate === 0
          <div
            style={{
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <div style={{ fontSize: 14, color: '#000000' }}>
              データがありません
            </div>
          </div>
        ) : (
          <ResponsiveBar
            groupMode='grouped'
            data={
              sortGraphData.length ? sortGraphData : graphStatuses.graphStatus
            }
            keys={sortValue}
            indexBy='assignee_user'
            margin={{
              top: 20,
              right: 0,
              bottom: 30,
              left: Math.max(targetSales).toString().length === 0 ? 40 : 90
            }}
            padding={0.3}
            valueScale={{ type: 'linear' }}
            indexScale={{ type: 'band', round: true }}
            colors={['#CCCCCC', mainColor]}
            borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            label={''}
            labelSkipWidth={12}
            labelSkipHeight={12}
            labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
            animate={true}
            motionConfig={{
              mass: 1,
              tension: 90,
              friction: 15,
              clamp: false,
              precision: 0.01,
              velocity: 0
            }}
            axisBottom={{ tickSize: 5 }}
            tooltip={({ value, color, indexValue }) => {
              return (
                <div
                  style={{
                    alignItems: 'center',
                    display: 'flex',
                    backgroundColor: 'white',
                    padding: '0.25rem'
                  }}
                >
                  {' '}
                  <div className='square' style={{ backgroundColor: color }} />
                  <div>
                    {indexValue}
                    {' : '}
                    <span style={{ fontWeight: 'bold' }}>
                      {value.toLocaleString()}
                    </span>
                  </div>
                </div>
              );
            }}
          />
        )}
      </div>
    </div>
  );
};
